export enum InsuranceOfficeType {
EFKA,
TEKA,
TEA,
Private,
}
